import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  saveLoading: false,
  workflowEmployees: [],
  workflowEmployeesLength: 0,
  error: '',
  successMessage: ''
};

export default function WFlowEmpleadosReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_WORKFLOW_EMP:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_WORKFLOW_EMP:
      return { ...state, saveLoading: action.payload };
    case actions.WORKFLOW_EMP_ERROR:
      return { ...state, error: action.payload };
    case actions.MESSAGE_SAVE_WORKFLOW_EMP:
      return {...state, successMessage: action.payload};
    case actions.GET_WORKFLOWS_EMP:
      return {
        ...state,
        workflowEmployees: action.payload.workflowEmployees, workflowEmployeesLength: action.payload.workflowEmployeesLength
      };
    default:
      return state;
  }
}
